<template>
  <v-container>
      <v-layout justify-center>
          <v-flex xs12 sm12 md10>
            <DataTableMain :datatable="table" :on-success="successAction" :itemsAction="tableAction"/>
          </v-flex>
      </v-layout>
  </v-container>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex'
import DataTableMain from '@/components/tables/DataTableMain'
export default {
  data: () => ({
    table: {
      header: {
        options: [
          { title: 'Refrescar', icon: 'mdi-cached', color: 'primary', action: 'refreshData', code: 'libre', hidden: '' },
          { title: 'Nuevo', icon: 'mdi-plus', color: 'success', action: 'newData', code: 'libre', hidden: '' }
        ],
        titles: [
          { text: 'id', value: 'id', class: 'black--text' },
          { text: 'Clave', value: 'clave', class: 'black--text' },
          { text: 'Categoria', value: 'nombre', class: 'black--text' },
          { text: 'Activo', value: 'Activo', class: 'black--text' },
          { text: '', value: 'Actions', class: 'black--text' }
        ],
        loading: false
      },
      body: {
        data: [],
        actions: []
      },
      footer: {
        paging: true
      }
    },
    puesto: {}
  }),
  components: {
    DataTableMain
  },
  mounted () {
    this.getUrl('POST/nomina/config/categorias/show')
  },
  methods: {
    successAction (item) {
      this[item.action](item)
    },
    refreshData (item) {
      this.table.header.loading = true
      this.getUrl('POST/nomina/config/categorias/show')
    },
    newData (item) {
      this.puesto = {}
      this.SHOW_DIALOG_MAIN({ type: 'create', with: 850, title: 'Nueva Plaza' })
    },
    tableAction (item) {
      this[item.action](item)
    },
    ...mapActions(['getUrlServices', 'postServiceListAction']),
    getUrl (objet) {
      if (this.get_urls != null) {
        const router = this.get_urls[objet]
        this.postServiceListAction({ url: router, data: {} })
      } else {
        this.getUrlServices()
      }
    },
    ...mapMutations(['SHOW_DIALOG_MAIN', 'CLEAR_DATA_LIST'])
  },
  computed: {
    ...mapGetters(['get_dialogMain', 'get_urls', 'get_objects'])
  },
  watch: {
    get_urls () {
      this.getUrl('POST/nomina/config/categorias/show')
    },
    get_objects (vals) {
      if (vals) {
        this.table.header.loading = false
        this.table.body.data = vals
      }
    }
  },
  beforeDestroy () {
    this.CLEAR_DATA_LIST()
  }

}
</script>

<style>

</style>
